import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-show-stops-checkbox',
  template: `
    <div class="form-check d-flex align-items-center me-4 cursor-pointer">
      <input type="checkbox" [formControl]="checkbox" class="form-check-input" id="show-stops-checkbox" />
      <label for="show-stops-checkbox" class="form-check-label h4 cursor-pointer">
        {{ 'dashboard.stopsCheckboxLabel' | transloco }}
      </label>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowStopsCheckboxComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  checkbox = new UntypedFormControl();

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) {}

  ngOnInit(): void {
    const routeChangeSubscription = this.checkbox.valueChanges.subscribe((value) => {
      const queryParams = {
        hideStops: 0,
      };
      if (!value) {
        queryParams.hideStops = 1;
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        queryParamsHandling: 'merge',
      });
    });
    const setCheckboxValueFromRouteSubscription = this.route.queryParams.subscribe((value) => {
      const hideVehicles = value.hideStops || false;
      if (+hideVehicles) {
        this.checkbox.patchValue(false);
        return;
      }
      this.checkbox.patchValue(true);
    });
    this.subscription.add(routeChangeSubscription);
    this.subscription.add(setCheckboxValueFromRouteSubscription);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
